import { render, staticRenderFns } from "./NikudEdit.vue?vue&type=template&id=13ee6094&scoped=true&"
import script from "./NikudEdit.vue?vue&type=script&lang=js&"
export * from "./NikudEdit.vue?vue&type=script&lang=js&"
import style0 from "./NikudEdit.vue?vue&type=style&index=0&id=13ee6094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee6094",
  null
  
)

export default component.exports